module.exports = __webpack_public_path__ + "img/bank-bca.1dd07057.png";